/**
 * 账号中心回调错误码 → 面向用户的中文提示。
 *
 * 回调失败时账号中心会把 `?auth_error=<code>` 带回本站首页（见边缘层 src/workers/edge/oidc.ts），
 * 这里负责把它翻译成人话并清理地址栏。错误码与 CloudTools 的接入保持一致。
 */

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  account_center_unconfigured: '登录服务尚未配置完成，请联系管理员',
  database_unavailable: '账号服务暂不可用，请稍后再试',
  missing_code: '登录未完成，请重试',
  state_mismatch: '登录会话已过期，请重新登录',
  session_expired: '登录超时，请重新登录',
  token_exchange_failed: '登录校验失败，请重试',
  invalid_id_token: '登录凭证校验失败，请重试',
  missing_email_scope: '账号缺少邮箱信息，请联系管理员',
  missing_sub: '账号标识缺失，请联系管理员',
  local_user_failed: '本地账号创建失败，请稍后再试',
  account_disabled: '账号已被停用，请联系管理员',
  rate_limited: '操作过于频繁，请稍后再试',
};

export interface AuthErrorInfo {
  code: string;
  message: string;
}

/** 读取并清理地址栏里的 auth_error（返回 null 表示本次没有错误） */
export function consumeAuthError(search: string, onClean: (nextSearch: string) => void): AuthErrorInfo | null {
  const params = new URLSearchParams(search);
  const code = params.get('auth_error');
  if (!code) return null;

  params.delete('auth_error');
  const query = params.toString();
  onClean(query ? `?${query}` : '');

  return { code, message: AUTH_ERROR_MESSAGES[code] ?? '登录失败，请重试' };
}
